import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import CategorySection from './components/CategorySection';
import WhatIsSection from './components/WhatIsSection';
import FeaturesSection from './components/FeaturesSection';
import TrendingSection from './components/TrendingSection';
import ArticleCardsSection from './components/ArticleCardsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as const });
  }, [pathname]);
  return null;
}

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <CategorySection />
        <WhatIsSection />
        <FeaturesSection />
        <TrendingSection />
        <ArticleCardsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}